import React from 'react';
import cx from 'classnames';

export interface Tab {
  id: string;
  label: React.ReactNode;
  icon?: React.ReactNode;
  badge?: number;
}

export interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

export const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className,
}) => {
  return (
    <div className={cx("flex flex-row gap-2 border-b-1 border-gray-400", className)}>
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={cx(
            "relative flex flex-row items-center gap-2 p-2 rounded-t-md border-1 border-b-0 border-gray-400 cursor-pointer",
            activeTab === tab.id
              ? 'bg-white text-gray-800 border-b-white border-b-1'
              : 'bg-gray-200 text-gray-500 border-b-gray-400 border-b-1'
          )}
          style={{
            marginBottom: '-1px',
          }}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.icon && <span>{tab.icon}</span>}
          {tab.label}

          <span
            className="text-md text-white font-bold bg-red-500 rounded-full absolute text-center"
            style={{
              lineHeight: '1',
              top: '-7px',
              right: '-7px',
              width: '20px',
              height: '20px',
              display: tab.badge ? 'block' : 'none',
            }}
          >
            {tab.badge}
          </span>
        </div>
      ))}
    </div>
  );
};

export default Tabs;
